<template>
  <section
    id="price"
    class="flex flex-col items-center justify-center bg-[#FFF]"
  >
    <h2
      class="relative mx-10 mt-16 text-center text-[32px] font-bold uppercase"
    >
      Ceník
      <span
        class="absolute bottom-[-35px] left-1/2 h-1 w-10 -translate-x-1/2 transform bg-primary"
      ></span>
    </h2>

    <div class="mx-10 my-20 text-center leading-6" data-aos="fade">
      <p class="mx-auto max-w-3xl text-balance">
        Nabízím možnost částečného proplacení pojišťovnami:
        <span class="text-primary">VZP, ČPZP, VoZP a dalšími</span>. Bližší
        informace Vám podám na níže uvedeném telefonním čísle.
      </p>

      <br />
      <br />
      <p class="max-w-4xl">
        Někdy se stane, že není možné se na sjednanou schůzku dostavit. Dejte mi
        prosím vědět <span class="text-primary">alespoň 48 hodin předem</span>,
        abych mohla váš čas nabídnout jinému zájemci. V případě, že mi vědět
        nedáte, budu Vám vaší neuskutečněnou konzultaci účtovat
        <span class="text-primary">dle platné sazby</span>. Děkuji za pochopení.
      </p>
    </div>

    <div class="mb-20 flex max-w-5xl p-10 flex-col gap-3 w-full " data-aos="fade">
      <p>Ceník od <b class="text-secondary">1.1.2026</b></p>
      <div
        v-for="row in priceRow"
        :key="row.title"
        class="bg-[#DDF3ED] px-4 py-4"
      >
        <ul
          class="mx-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
        >
          <li>{{ row.title }}</li>
          <li class="font-bold text-secondary">{{ row.price }}</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
const priceRow = [
  {
    title: "Individuální terapie (50 min)",
    price: "1000 Kč",
  },
  {
    title: "Párové a rodinné poradenství (1 hodina 30 min)",
    price: "2000 Kč",
  },
];
</script>

<style scoped></style>
